import { render, staticRenderFns } from "./rmMassBalanceDetailViewPopUp.vue?vue&type=template&id=0bbb6c90&scoped=true&"
import script from "./rmMassBalanceDetailViewPopUp.vue?vue&type=script&lang=js&"
export * from "./rmMassBalanceDetailViewPopUp.vue?vue&type=script&lang=js&"
import style0 from "./rmMassBalanceDetailViewPopUp.vue?vue&type=style&index=0&id=0bbb6c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb6c90",
  null
  
)

export default component.exports